<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    let xAxisData = ["3.1", "3.2", "3.3", "3.4", "3.2", "3.3", "3.4"]
  let seriesData = [100, 200, 300, 200, 200, 300, 200]
    this.state.chart.setOption({
        grid: {
          left: '5%',
          right: '5%',
          top: '15%',
          bottom: '5%',
          containLabel: true,
      },
      tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function (params) {
            return params[0].name + ': ' + params[0].value;
          }
      },
      xAxis: {
          data: xAxisData,
          axisTick: { show: true },
          axisLine: { show: true },
          axisLabel: {
            // interval: 0,
            fontSize: 30,
              textStyle: {
                color: '#CED0D2',//坐标值得具体的颜色,
                fontSize: 30
            }

          },
      },
      yAxis: {
          splitLine: { show: true,
            lineStyle: {
                  type: 'dashed',
                  color: '#6D7478',//左边线的颜色
                  width: '1'//坐标线的宽度
            } 
            },
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { 
            show: true,
            textStyle: {
                color: '#CED0D2',//坐标值得具体的颜色,
                fontSize: 30
            },
            formatter: function(value) {
              // 当值为 0 时不显示标签
              return value === 0 ? '' : value;
            }
        }

      },

      color: ['#e54035'],
      series: [{
          name: 'hill',
          type: 'pictorialBar',
          barCategoryGap: '-60%',
          symbolClip: true,
          symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
          itemStyle: {
            normal: {
                borderColor: '#3CB4B5',
                borderWidth:6,
                color: function (params) {
                  return {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 1,
                      y2: 0,
                      colorStops: [{
                        offset: 0,
                        color: "rgba(15,125,110,1)"
                      },
                      {
                        offset: 0.3,
                        color:  "rgba(15,125,110,1)"
                      },
                      {
                        offset: 1,
                        color:  "rgba(15,125,110,.2)"
                      }
                      ],
                      global: false //  缺省为  false
                  }
                }
            },
            emphasis: {
                opacity: 1
            },
          },
          label: {
            show: true,
            position: 'top',
            // offset: [0, 0],
            fontSize: 30,
            backgroundColor:"transparent",
            color:"rgba(255,255,255,.8)",
            formatter: function (params) {
                
                let str = params.value + "次";;
                return str;
            }
          },
          emphasis: {
            itemStyle: {
                opacity: 1
            }
          },
          data: seriesData,
          z: 10
      }]
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
